import { Lock, Users } from 'lucide-react'

interface NoteVisibilityBadgeProps {
  visibility: 'private' | 'shared'
  onClick?: () => void
  clickable?: boolean
}

export default function NoteVisibilityBadge({ visibility, onClick, clickable = false }: NoteVisibilityBadgeProps) {
  const isPrivate = visibility === 'private'
  const Icon = isPrivate ? Lock : Users
  const label = isPrivate ? 'Private' : 'Shared'
  const colors = isPrivate ? 'text-gray-500 bg-gray-100' : 'text-blue-600 bg-blue-50'

  const className = `inline-flex items-center gap-1 px-1.5 py-0.5 text-xs rounded ${colors} ${
    clickable ? 'cursor-pointer hover:opacity-80' : ''
  }`

  if (clickable && onClick) {
    return (
      <button onClick={onClick} className={className} title={`Click to make ${isPrivate ? 'shared' : 'private'}`}>
        <Icon className="w-3 h-3" />
        {label}
      </button>
    )
  }

  return (
    <span className={className} title={label}>
      <Icon className="w-3 h-3" />
      {label}
    </span>
  )
}
